import { useCache } from '@/store/web/useCache'
// import { useStore } from "vuex";
import store from '@/store'

const { wsCache } = useCache()
// const store = useStore();

const AccessTokenKey = 'ACCESS_TOKEN'
const RefreshTokenKey = 'REFRESH_TOKEN'

// 获取访问token
export const getAccessToken = () => {
  // 此处与TokenKey相同，此写法解决初始化时Cookies中不存在TokenKey报错
  const accessToken = wsCache.get(AccessTokenKey)
  console.log('q1111111'+accessToken)
  return accessToken ? accessToken : wsCache.get('ACCESS_TOKEN')
}

// 获取刷新token
export const getRefreshToken = () => {
  return wsCache.get(RefreshTokenKey)
}

// 设置访问token
export const setAccessToken = (data) => {
  wsCache.set(AccessTokenKey, data.accessToken)
  store.commit("setAccessToken", data.accessToken)
}

// 设置刷新token
export const setRefreshToken = (data) => {
  wsCache.set(RefreshTokenKey, data.refreshToken)
  store.commit("setRefreshToken", data.refreshToken)
}

// 设置token
export const setToken = (data) => {
  wsCache.set(RefreshTokenKey, data.refreshToken)
  wsCache.set(AccessTokenKey, data.accessToken)
  store.commit("setAccessToken", data.accessToken)
  store.commit("setRefreshToken", data.refreshToken)
  // wsCache.set('isLogin', true)
  // store.commit("setToken", true);
}

// 删除token
export const removeToken = () => {
  wsCache.delete(AccessTokenKey)
  wsCache.delete(RefreshTokenKey)
  store.commit("setToken", false);
          store.commit("setUserId", "");
          store.commit("setUsername", "");
          store.commit("setUserPic", "");
          store.commit("setAccessToken", "");
          store.commit("setRefreshToken", "");
          store.commit("setMyInfo", {});
          store.commit("setMyDetailInfo", {});
          store.commit("setShowAside", false);
}

/** 格式化token（jwt格式） */
export const formatToken = (token: string): string => {
  return 'Bearer ' + token
}

